// Tiny helpers for HTML5 drag-and-drop reorder.
//
// Used by the server rail (per-user space order) and the channel
// sidebar (per-space channel order, owner-only). Both are local-
// optimistic with a 2-second debounce for the eventual API write
// (Req 17.4).

/** Move the element at `from` to position `to`, returning a new array. */
export function moveItem<T>(arr: ReadonlyArray<T>, from: number, to: number): T[] {
  if (from === to) return [...arr];
  const out = [...arr];
  const [item] = out.splice(from, 1);
  if (item === undefined) return [...arr];
  // Adjust insertion index when the source comes before the target.
  const insertAt = from < to ? to - 1 : to;
  out.splice(insertAt, 0, item);
  return out;
}
